import { Link, NavLink, useLocation, Outlet } from 'react-router-dom';
import styles from './Public.module.css';

export default function PublicLayout() {
    const { pathname } = useLocation();

    return (
        <div className={styles.pageRoot}>
            <header className={`${styles.homeHeader} ${pathname === '/' ? styles.homeHeaderAbsolute : ''}`}>
                <div className={styles.homeHeaderLeft}>
                    <div className={styles.homeHeaderBrandSub}>화재 확산 및 피난 경로 안내 웹서비스</div>
                    <Link to="/" className={styles.homeHeaderBrand}>
                        FirST SIM
                    </Link>
                </div>

                <div className={styles.homeHeaderRight}>
                    <div className={styles.homeHeaderAuth}>
                        <Link to="/login">로그인</Link>
                        <span className={styles.divider} />
                        <Link to="/signup">회원가입</Link>
                    </div>

                    <nav className={styles.homeHeaderNav}>
                        <NavLink to="/notices" className={({ isActive }) => (isActive ? 'active' : undefined)}>
                            공지사항
                        </NavLink>
                        <NavLink to="/service" className={({ isActive }) => (isActive ? 'active' : undefined)}>
                            서비스안내
                        </NavLink>
                        <NavLink to="/pricing" className={({ isActive }) => (isActive ? 'active' : undefined)}>
                            요금안내
                        </NavLink>
                        <NavLink to="/support" className={({ isActive }) => (isActive ? 'active' : undefined)}>
                            고객지원
                        </NavLink>
                    </nav>
                </div>
            </header>

            <Outlet />
            <footer className={styles.footer}>COPYRIGHT (C) REALTIMETECH INC. ALL RIGHTS RESERVED. | v{process.env.REACT_APP_VERSION}</footer>
        </div>
    );
}
